export default __webpack_public_path__ + "static/media/logo.80c8210d.svg";